module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_67520887_L-36ca90430d88d0128e3286881bf66bc4.jpg";